// extracted by mini-css-extract-plugin
module.exports = {"signUpContainer":"SignUpComponent_signUpContainer__p5d-d","signInLinkContainer":"SignUpComponent_signInLinkContainer__riK3e"};